import axios from "axios";

const login = async (email, password) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/auth/login`, {
      email,
      password
    })
    .then((response) => {
      const { data } = response;
      if (!data.accessToken) {
        throw Error("No Token!");
      }
      return data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const logout = async (refreshToken) => {
  const config = {
    headers: {
      Authorization: `Bearer ${refreshToken}`
    }
  };

  return axios
    .post(`${process.env.REACT_APP_API_URL}/auth/logout`, {}, config)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const refresh = async (refreshToken) => {
  const config = {
    headers: {
      Authorization: `Bearer ${refreshToken}`
    }
  };

  return axios
    .post(`${process.env.REACT_APP_API_URL}/auth/refresh`, {}, config)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const AuthService = { login, logout, refresh };

export default AuthService;
